import React from 'react';
import { consumerFeatures } from '../mock/mock';
import { FileText, ShieldCheck, BellRing, Download } from 'lucide-react';
import { Button } from './ui/button';

const iconMap = { FileText, ShieldCheck, BellRing };

const ConsumerApp = () => {
  return (
    <section className="bg-white py-16 lg:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full bg-orange-50 text-orange-600 text-sm font-medium border border-orange-100 mb-4">For Consumers</span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0F2A4B]">InsureRiskFree Consumer App</h2>
          <p className="mt-3 text-slate-600 text-lg">All your insurance in one place</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1 space-y-5">
            {consumerFeatures.map((f, i) => {
              const Icon = iconMap[f.icon];
              return (
                <div key={f.title} className="bg-white rounded-2xl border border-slate-100 p-6 hover:shadow-lg hover:border-emerald-200 transition-all group">
                  <div className="flex gap-4">
                    <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-emerald-50 to-teal-50 flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform">
                      <Icon className="w-6 h-6 text-[#00B48E]" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-lg text-[#0F2A4B] mb-1">{f.title}</h3>
                      <p className="text-slate-600 text-sm leading-relaxed">{f.desc}</p>
                    </div>
                  </div>
                </div>
              );
            })}
            <div className="flex flex-wrap gap-3 pt-2">
              <Button className="bg-black hover:bg-slate-800 text-white rounded-xl px-5 py-6 gap-2">
                <Download className="w-4 h-4" />
                <div className="text-left">
                  <div className="text-[10px] font-normal">GET IT ON</div>
                  <div className="text-sm font-semibold -mt-0.5">Google Play</div>
                </div>
              </Button>
              <Button className="bg-black hover:bg-slate-800 text-white rounded-xl px-5 py-6 gap-2">
                <Download className="w-4 h-4" />
                <div className="text-left">
                  <div className="text-[10px] font-normal">Download on the</div>
                  <div className="text-sm font-semibold -mt-0.5">App Store</div>
                </div>
              </Button>
            </div>
          </div>

          <div className="order-1 lg:order-2 relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4 pt-6">
                <div className="bg-gradient-to-br from-emerald-500 to-teal-600 rounded-3xl p-6 text-white shadow-lg h-48 flex flex-col justify-between">
                  <FileText className="w-8 h-8" />
                  <div>
                    <div className="text-xs opacity-80">Active Policies</div>
                    <div className="text-3xl font-bold">4</div>
                  </div>
                </div>
                <div className="bg-white rounded-3xl p-6 shadow-md border border-slate-100 h-40">
                  <BellRing className="w-7 h-7 text-orange-500 mb-3" />
                  <div className="text-xs text-slate-500">Renewal Due</div>
                  <div className="text-base font-bold text-[#0F2A4B]">Car Insurance</div>
                  <div className="text-xs text-orange-600 mt-1">Due in 12 days</div>
                </div>
              </div>
              <div className="space-y-4">
                <div className="bg-white rounded-3xl p-6 shadow-md border border-slate-100 h-40">
                  <ShieldCheck className="w-7 h-7 text-emerald-600 mb-3" />
                  <div className="text-xs text-slate-500">Claims Resolved</div>
                  <div className="text-3xl font-bold text-[#0F2A4B]">12K+</div>
                  <div className="text-xs text-emerald-600 mt-1">This month</div>
                </div>
                <div className="bg-[#0F2A4B] text-white rounded-3xl p-6 shadow-lg h-48 flex flex-col justify-between">
                  <div className="flex items-center gap-2">
                    <div className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
                    <span className="text-xs">Live Support</span>
                  </div>
                  <div>
                    <div className="text-xs opacity-70">Expert Advisors</div>
                    <div className="text-2xl font-bold">Available 24/7</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConsumerApp;
